export default __webpack_public_path__ + "static/media/feature_search.fc27aa9f.png";